import { HeaderMenuItemsStore } from "./header-menu-items.store";

export const HeaderMenuItemStore =  new HeaderMenuItemsStore()